module.exports = __webpack_public_path__ + "static2024-7-11/img/bottom-teenage.74b3935c.png";